module.exports = __webpack_public_path__ + "static/media/SearchIcoLycos.73f7840f.png";